export const money = (value: number): string =>
  "R$" + Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 2 });

const DOW = ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"];
const DOW_FULL = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"];
const MONTHS = [
  "janeiro",
  "fevereiro",
  "março",
  "abril",
  "maio",
  "junho",
  "julho",
  "agosto",
  "setembro",
  "outubro",
  "novembro",
  "dezembro",
];

export const parseISODate = (iso: string): Date => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const shortDow = (iso: string): string => DOW[parseISODate(iso).getDay()];

export const dayMonth = (iso: string): string => {
  const d = parseISODate(iso);
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const dateLabel = (iso: string): string => {
  const d = parseISODate(iso);
  return `${DOW_FULL[d.getDay()]}, ${d.getDate()} de ${MONTHS[d.getMonth()]}`;
};

// All Tue–Sat days between two ISO dates (inclusive) — mirrors the backend
// window rule so full days can render as "lotado" (they come absent from the
// station's days list).
export const tueSatBetween = (startIso: string, endIso: string): string[] => {
  const out: string[] = [];
  const end = parseISODate(endIso);
  for (let d = parseISODate(startIso); d <= end; d.setDate(d.getDate() + 1)) {
    const dow = d.getDay();
    if (dow >= 2 && dow <= 6) {
      out.push(
        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
          d.getDate(),
        ).padStart(2, "0")}`,
      );
    }
  }
  return out;
};
